import { renderDate, renderDateValue } from '../utility/addressTabGridHelper';

export const AGENCY_FILTER_UNASSIGNED_CODE = 'Unassigned';

export const DURATION_CODE = {
  ALL: 'All',
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
  OVER_MONTH: 'Over-Month',
};

export const AGENCY_FILTER_DEFAULT_VALUES = { AgencyFilter: null, Duration: DURATION_CODE.ALL };

export const HISTORY_GRID_COLUMNS = [
  { field: 'EventID', headerName: 'Event ID', width: 150 },
  { field: 'CallType', headerName: 'Event Type', width: 130 },
  { field: 'Status', headerName: 'Status', width: 120 },
  { field: 'AgencyID', headerName: 'Agency ID', width: 160 },
  { field: 'CaseID', headerName: 'Case ID', width: 160 },
  { field: 'Received', headerName: 'Received', width: 180, valueFormatter: renderDate },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 130 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 130 },
  { field: 'IsDeleted', headerName: 'Is Deleted', width: 120, type: 'boolean' },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 130 },
  { field: 'DeletedIP', headerName: 'Deleted IP', width: 130 },
];

export const DETAIL_FIELDS = [
  { field: 'EventID', label: 'Event ID' },
  { field: 'CallType', label: 'Event Type' },
  { field: 'Status', label: 'Status' },
  { field: 'AgencyID', label: 'Agency ID' },
  { field: 'CaseID', label: 'Case ID' },
  { field: 'Created', label: 'Created', render: renderDateValue },
  { field: 'CreatedBy', label: 'Created By' },
  { field: 'Updated', label: 'Updated', render: renderDateValue },
  { field: 'UpdatedBy', label: 'Updated By' },
  { field: 'IsDeleted', label: 'Is Deleted' },
  { field: 'DeletedBy', label: 'Deleted By' },
  { field: 'DeletedIP', label: 'Deleted IP' },
];

export const DURATION_OPTIONS = [
  { Code: DURATION_CODE.ALL, Description: 'All' },
  { Code: DURATION_CODE.DAY, Description: 'Last 24 hours' },
  { Code: DURATION_CODE.WEEK, Description: 'Last 7 days' },
  { Code: DURATION_CODE.MONTH, Description: 'Last 30 days' },
  { Code: DURATION_CODE.OVER_MONTH, Description: 'More than 30 days' },
];
